export default defineNuxtPlugin((nuxtApp) => {
    const api = $fetch.create({
        baseURL: 'https://survey.chocolatescorecard.com/api',
        onRequest({ request, options, error }) {
        /* if (session.value?.token) {

          options.headers.set('Authorization', `Bearer ${session.value?.token}`)
        } */
        },
        async onResponseError({ response }) {
            if (response.status === 401) {
                await nuxtApp.runWithContext(() => navigateTo('/'))
            }
        },
    })

    // Expose to useNuxtApp().$api
    return {
        provide: {
            api,
        },
    }
})
